import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { HeaderComponent } from '@app/layouts/post-auth-layout/header/header.component';
import { FooterComponent } from '@app/layouts/post-auth-layout/footer/footer.component';

@Component({
  selector: 'app-home-layout',
  imports: [HeaderComponent, FooterComponent, NzLayoutModule, RouterOutlet],
  templateUrl: './homeLayout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./homeLayout.component.scss'],
})
export class HomeLayoutComponent {
  isCollapsed = false;
  sidebarWidth = 0;

  toggleSidebar(): void {
    this.isCollapsed = !this.isCollapsed;
    this.sidebarWidth = window.innerWidth < 768 ? 0 : 80;
  }
}
